import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CharterFilingService,
  type Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassSnapshotsDto,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { type TableError } from '../../types/common';

const usePutStockClassSnapshots = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void,
  onError?: (message: string, errors: TableError[]) => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassSnapshotsDto,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassSnapshotsDto) => {
      return await handleRequest(
        CharterFilingService.putApiCapTableApiAppCharterFilingStockClassSnapshots(payload)
      );
    },
    {
      onSuccess: async () => {
        toast.success(
          <ToastComponent label='Success' message='Stock class snapshots updated successfully.' />
        );
        await queryClient.invalidateQueries('getCharterStockClassList');
        await queryClient.invalidateQueries('getCharterFilings');
        onClose?.();
      },
      onError: (err: any) => {
        console.error('Update stock class snapshots error', err);
        onError?.(err?.message, err?.errors);
        onClose?.();
      },
    }
  );
};

export default usePutStockClassSnapshots;
